import { createGetEndpoint } from '@sonar-software/sonar-http';
import { OrganizationMetadataGroup } from '../@types';

export const getAllOrganizations = createGetEndpoint<void, OrganizationMetadataGroup>(
	'/api/v3/core/organizations/all'
);
